import { ChevronRight, Home } from 'lucide-react'
import { Link, useLocation } from 'react-router-dom'
import { useEffect } from 'react'

const Breadcrumb = () => {
  const location = useLocation()
  const pathnames = location.pathname.split('/').filter(x => x)

  const breadcrumbNameMap: { [key: string]: string } = {
    '': 'Home',
    carrinho: 'Carrinho de Compras',
    checkout: 'Finalizar Compra',
    blog: 'Blog',
    faq: 'Perguntas Frequentes',
    sobre: 'Sobre Nós',
    contato: 'Contato',
    privacidade: 'Política de Privacidade',
    entrar: 'Login',
    produtos: 'Produtos',
    parceria: 'Seja Parceiro',
  }

  if (location.pathname === '/') {
    return null
  }

  // Gerar structured data para SEO
  const generateStructuredData = () => {
    const baseUrl = window.location.origin
    const itemListElement = [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: baseUrl,
      },
    ]

    pathnames.forEach((value, index) => {
      const url = `${baseUrl}/${pathnames.slice(0, index + 1).join('/')}`
      const name =
        breadcrumbNameMap[value] ||
        value.charAt(0).toUpperCase() + value.slice(1)

      itemListElement.push({
        '@type': 'ListItem',
        position: index + 2,
        name: name,
        item: url,
      })
    })

    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement,
    }
  }

  // Adicionar structured data ao head
  useEffect(() => {
    const structuredData = generateStructuredData()
    const script = document.createElement('script')
    script.type = 'application/ld+json'
    script.text = JSON.stringify(structuredData)
    script.id = 'breadcrumb-schema'

    // Remover script anterior se existir
    const existingScript = document.getElementById('breadcrumb-schema')
    if (existingScript) {
      existingScript.remove()
    }

    document.head.appendChild(script)

    return () => {
      const scriptToRemove = document.getElementById('breadcrumb-schema')
      if (scriptToRemove) {
        scriptToRemove.remove()
      }
    }
  }, [location.pathname])

  return (
    <nav
      className="bg-muted/30 border-b border-border py-4"
      aria-label="Breadcrumb"
    >
      <div className="container mx-auto px-4">
        <ol
          className="flex items-center space-x-2 text-sm md:text-base"
          itemScope
          itemType="https://schema.org/BreadcrumbList"
        >
          <li
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem"
          >
            <Link
              to="/"
              itemProp="item"
              className="flex items-center text-muted-foreground hover:text-primary transition-colors font-medium"
            >
              <Home className="h-5 w-5" />
              <meta itemProp="name" content="Home" />
            </Link>
            <meta itemProp="position" content="1" />
          </li>
          {pathnames.map((value, index) => {
            const last = index === pathnames.length - 1
            const to = `/${pathnames.slice(0, index + 1).join('/')}`
            const name =
              breadcrumbNameMap[value] ||
              value.charAt(0).toUpperCase() + value.slice(1)

            return (
              <li
                key={to}
                className="flex items-center"
                itemProp="itemListElement"
                itemScope
                itemType="https://schema.org/ListItem"
              >
                <ChevronRight className="h-5 w-5 mx-2 text-muted-foreground" />
                {last ? (
                  <>
                    <span
                      className="text-foreground font-semibold"
                      itemProp="name"
                    >
                      {name}
                    </span>
                    <meta itemProp="position" content={String(index + 2)} />
                  </>
                ) : (
                  <>
                    <Link
                      to={to}
                      itemProp="item"
                      className="text-muted-foreground hover:text-primary transition-colors font-medium"
                    >
                      <span itemProp="name">{name}</span>
                    </Link>
                    <meta itemProp="position" content={String(index + 2)} />
                  </>
                )}
              </li>
            )
          })}
        </ol>
      </div>
    </nav>
  )
}

export default Breadcrumb
